export const getHostname = (value: string): string => {
  const trimmedValue = value.trim();

  try {
    return new URL(trimmedValue.includes('://') ? trimmedValue : `https://${trimmedValue}`).hostname;
  } catch {
    return trimmedValue.replace(/^https?:\/\//, '').split('/')[0];
  }
};

export const isLegacyHostname = (hostname: string): boolean => {
  const normalizedHostname = hostname.toLowerCase();

  return normalizedHostname === 'alucio.io' || normalizedHostname.endsWith('.alucio.io');
};

export const isLegacyPreferredDomain = (preferredDomain?: string): boolean => {
  const trimmedPreferredDomain = preferredDomain?.trim();

  return !trimmedPreferredDomain || isLegacyHostname(getHostname(trimmedPreferredDomain));
};

const DR_HOSTNAME_BY_PRIMARY: Record<string, string> = {
  'qa.beacon.medispend.com': 'qadr.beacon.medispend.com',
  'preview.beacon.medispend.com': 'previewdr.beacon.medispend.com',
  'beacon.medispend.com': 'proddr.beacon.medispend.com',
};

export const shouldBlockDomainMigration = (
  preferredDomain: string | undefined,
  currentOrigin: string = window.location.origin,
): boolean => {
  if (!preferredDomain) return false;

  const preferredHostname = getHostname(preferredDomain);
  const currentHostname = getHostname(currentOrigin);

  // Comment out this guard to test the domain migration locally.
  if (currentHostname === 'localhost') return false;

  if (isLegacyPreferredDomain(preferredDomain)) {
    return false;
  }

  return currentHostname !== preferredHostname &&
    currentHostname !== DR_HOSTNAME_BY_PRIMARY[preferredHostname];
};
